import { render, staticRenderFns } from "./fulfilGiveFreeFreight.vue?vue&type=template&id=f00eeafa&"
import script from "./fulfilGiveFreeFreight.vue?vue&type=script&lang=js&"
export * from "./fulfilGiveFreeFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports